import {useMemo} from 'react';
import type {WorkflowDefinitionPhaseResponse} from 'src/api/ProactApiClient';

/**
 * Checks whether any downstream phases reference the given phase's slug
 * in their email or task action metadata (subject/body/content).
 * Returns true if changing or removing the slug could break references.
 */
export const useSlugReferenceWarning = (
  slug: string | undefined,
  allPhases: WorkflowDefinitionPhaseResponse[],
  currentPhaseIndex: number
): boolean => {
  return useMemo(() => {
    if (!slug) return false;

    const downstreamPhases = allPhases.slice(currentPhaseIndex + 1);
    return downstreamPhases.some(p =>
      p.actions?.some(a => {
        const emailSubject = a.metadata?.emailMetadata?.subject ?? '';
        const emailBody = a.metadata?.emailMetadata?.body ?? '';
        const taskSubject = a.metadata?.createTaskMetadata?.subject ?? '';
        const taskContent = a.metadata?.createTaskMetadata?.content ?? '';
        return (
          emailSubject.includes(slug) ||
          emailBody.includes(slug) ||
          taskSubject.includes(slug) ||
          taskContent.includes(slug)
        );
      })
    );
  }, [slug, allPhases, currentPhaseIndex]);
};
